import { CORE } from "./commonRepository";

/**
 * List of bot types
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const GetAll = async (filter) =>{
    try{
        const result = await CORE.get('v1/botTypes', {
            params: filter
        });
        return result;
    }catch(error){
        return error.response;
    }
};